import React from 'react';
import Header from '../components/DRHeader';
import CurrentStatusView from '../components/CurrentStatusView';
import VersionDisplay from '../components/VersionDisplay';
import QueueView from '../components/QueueView';
import { noSelect, moxiVerdigris, noTouchAction, turqoiseBtnStyle } from '../constants/Styles';
import ERROR_PROMPT from '../constants/ErrorPrompt';
import { pickupTaskType, dropoffTaskType, setReloadTimeStr, setAudioPrimed, getAudioPrimed } from '../constants/Meta';
import { elasticLogEvent, elasticLogError, logSetSvcsUp } from '../vodjs/ElasticLog';
import { reloadNoCache } from '../vodjs/Network';
import ModalView from '../components/Modals';
import Dialog from '../components/Dialog';
import MoxiModalProvider from '../components/MoxiModalProvider';
import Loader from '../components/Loader';
import TaskStepView from '../vodjs/TaskStepView';
import { taskSubscribe, getCurrentView, getBatchTasks, securePt2Pt } from '../vodjs/TrackedTasks';
import { startHallpassCheckLoop, stopHallpassCheckLoop, hallpassHandleSpur } from '../components/HallpassLogin';
import ThinkingScreen from './ThinkingScreen';
import { env } from '../vodjs/settings';
import { ErrorBanner, DRButton } from '../components/DRControls';
import {  getUnitWp, getDeliveryType, getRobotId, canRelog, setRelog, clearRelog, interpretCommand, r2h, h2r,
  isKiosk, setLoadScreenShowFunc, initKioskSettings, refreshedSnapshot, getsIdsMoxspotNames, getR2HTable} from '../vodjs/lib';
import { extractFallbackTaskAttrs, extractTaskAttrs } from './utils/taskAttrs';
import ServiceUnavailableScreenNoButton from './ServiceUnavailableScreenNoButton';
import { getUntemplatedStatus } from '../vodjs/Task';
import sleep from 'sleep-promise';
import LoadScreen from './LoadScreen';
import UnloadScreen from './UnloadScreen';
import { subscribeSocialCue, subscribeStepStatus, subscribeEstop, subscribePollAll } from '../vodjs/PollMgr';
import { areSame, unsubscribe, isMobile, isTall, allowMulti, getHrsMinsAmpmStr, clearFetch, getShared, randomHex, throttleAllow} from '../vodjs/Utils';
import Audio, { briefSilence, arrivalSoundName } from '../constants/Audio';
import { TextDisplayView } from '../components/TextDisplayView';
import { fetchConf } from '../vodjs/DiligentEnv';
import { TASK_TYPE, STEP_TYPE, TASK_STATUS, V1_LOAD_STEP_TYPE, V1_UNLOAD_STEP_TYPE, ONE_TO_MANY, MANY_TO_ONE, DRAWER_CONFIDENCE } from '../constants/Tasks';
import { KIOSK_SETTINGS } from '../constants/KioskSettings';
import { getConfig, setConfig } from '../utils/configUtils';
import { getSettingValue } from '../utils/kioskSettingsUtils';
import { PollMgrRegister, PollMgrUnregister } from '../vodjs/PollMgr';
import BadgeReport from './BadgeReport';

export const ROBOT_IDLE_STATE = 'IDLE';
const ROBOT_OFFLINE_STATE = 'OFFLINE';
const CHECK_SERVICE_AVAILABLE_INTERVAL = 1000; //ticks
const ON_ERROR_AUTO_CLOSE_TIMEOUT = 10 * 1000; //ticks
const CHECK_DOOR_HELP_INTERVAL = 1000 * 2;

const mobile = isMobile();



//https://docs.google.com/document/d/1pNjatu_KWdlw1MJeVmiEnaHOvvaT4du1pv25QxJirrk/edit
const funFacts = `
1 Mile is approximately 2,000 steps, you can save miles with Moxi.
A Mox Spot is a specific location where Moxi makes deliveries.
Moxi can open automated doors by itself.
Moxi can ride elevators by itself.
Moxi has a remote support team available 24/7/365, this support team’s number is located at the bottom of Moxi's station kiosks.
Moxi has an e-stop button on its bottom left side for emergencies.
Moxi has an online resource center. Please scan the QR code found on kiosks to access this website.
Moxi has completed over 200,000 deliveries across the country.
Moxi has three drawers for secure deliveries.
Moxi is able to detect things in its path, like people and objects and spills.
Moxi is making deliveries coast-to-coast.
Moxi’s arm has 7 joints.
Moxi’s drawers can only be accessed by authorized users.
Moxi’s headband can change to four different colors.
Moxi’s hometown is Austin, TX.
Moxi’s large drawer can hold 2 IV pumps.
Moxi’s large drawer can hold 3 Peritoneal Dialysis Bags.
Moxi’s large drawer can hold 8 1-Liter saline bags.
Moxi’s large drawer can hold 9 Sani-Wipes.
`
  .split('\n')
  .map((f) => f.trim())
  .filter((x) => !!x);

export default class HomeScreen extends TaskStepView {
  constructor(props) {
    super(props);

    this.state = {
      actionsAndStatuses: undefined,
      modalScreen: null,
      showError: false,
      errorPrompt: ERROR_PROMPT.default,
      showTextDisplay: false,
      textDisplay: '',
      changeId: 1, //periodically bumped to force re-render
      kioskSettings: null,
      allKioskSettings: null,
      robotRecs: {},
    };
    this.robotSubs = {};

    this.presentModal = this.presentModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getEnabledKioskFriendlyNames = this.getEnabledKioskFriendlyNames.bind(this);
    this.getOpenHoursInfo = this.getOpenHoursInfo.bind(this);

    this.chimeTable = {};
    this.handleDimensionChange = this.handleDimensionChange.bind(this);

    this.tasks = [];

    this.showReloadScreen = this.showReloadScreen.bind(this);
  }

  initAutoUpdateListeners() {

    this.updateInterval = setInterval(() => {

      if (!this.updateRec) return; //nothing to do
      const updateRec = this.updateRec; //local copy

      let { modals: overrideModals, tasks: overrideTasks } = updateRec;

      let updateStrId = 'id-' + updateRec.id; //the leading id- to guarantee stringdom; elastic has been finicky

      if (this.state.modalScreen) {

        if (!overrideModals) {
          //don't interrupt a request being queued by the user
          if(updateRec.verbose)
            elasticLogEvent({ what: 'cmdOverrideModal', msg: `modal screen is showing, deferring cmd ${updateStrId}.`, updateStrId }, `cmdOverrideModal:${updateStrId}`);
          return;
        }

        if(updateRec.verbose)
          elasticLogEvent({ what: 'cmdOverrideModal', msg: `modal screen is showing, but overriding per cmd ${updateStrId}.`, updateStrId }, `cmdOverrideModal:${updateStrId}`);
      }

      if (getRobotId()) {
        let robotRec = this.state.robotRecs[getRobotId()];

        if (robotRec && robotRec.task_status != ROBOT_IDLE_STATE && robotRec.task_status != ROBOT_OFFLINE_STATE) {

          if (!overrideTasks) {
            if(updateRec.verbose)
              elasticLogEvent({ what: 'cmdOverrideTasks', msg: `robot taskStatus is ${robotRec.task_status}, deferring cmd ${updateStrId}.`, updateStrId }, `cmdOverrideTasks:${updateStrId}`);
            return;
          }

          if(updateRec.verbose)
            elasticLogEvent({ what: 'cmdOverrideTasks', msg: `robot taskStatus is ${robotRec.task_status}, but overriding per cmd ${updateStrId}.`, updateStrId }, `cmdOverrideTasks:${updateStrId}`);
        }
      }

      //note that for returns above, we don't untruthify this.updateRec, because we might come back to 
      //it (e.g. user might get done with modal, or task might complete).  But for everything here
      //onward, we untruthify it, i.e. we won't be back for future passes for this command.
      this.updateRec = undefined;

      if(updateRec.when && (getConfig()?.loadTicks || 0) >= updateRec.when) {
        //we have restarted since this command was issued, ignore it
        if(updateRec.verbose)
          elasticLogEvent({ what: 'laterLaunch', msg: `ignoring ${updateStrId} because launched later`, updateStrId, }, `laterLaunch:${updateStrId}`);
        return;
      }

      const LOCAL_UPDATE_ID_KEY = 'processedUpdateId';
      this.processedUpdateId = this.processedUpdateId || localStorage.getItem(LOCAL_UPDATE_ID_KEY);
      if (this.processedUpdateId == updateRec.id) {
        //We've already processed this command.
        console.log(`Previously processed cmd ${updateStrId}, ignoring.`);
        return;
      }

      let steps = updateRec.steps;
      if (typeof(steps) == 'string')
        steps = [steps]; //allows either single string or array
      let outcome = interpretCommand(steps);

      this.processedUpdateId = updateRec.id; //in-memory hedge against localStorage not being enabled

      if (outcome == 'done') {
        if(updateRec.verbose)
          elasticLogEvent({ what: 'noRelog', msg: `cmd ${updateStrId} does not apply (${steps.join(';')})`, updateStrId }, `noRelog:${updateStrId}`);
        return;
      }

      if (outcome == 'ping') {
        elasticLogEvent({ what: 'ping', msg: `ping from cmd ${updateStrId}.`, updateStrId });
        return;
      }

      if (outcome == 'stash') {
        elasticLogEvent({ what: 'stash', msg: `stash from cmd ${updateStrId}.`, updateStrId });
        const stashMinutes = 20; //long enough for new hexnode policies to take
        setRelog(undefined, stashMinutes);
        return;
      }

      if (outcome == 'clear') {
        elasticLogEvent({ what: 'clear', msg: `clear from cmd ${updateStrId}.`, updateStrId });
        clearRelog();
        return;
      }

      //by process of elimination, should be a reload
      if (outcome != 'reload') {
        elasticLogError({ what: 'unrecOutcome', msg: `unrecognized outcome from cmd ${updateStrId}: ${outcome}.`, updateStrId }, `unrecOutcome:${updateStrId}`);
        return;
      }

      ////hibernating: we'd need to have an Op present to handle logging in... so don't reload without it
      //// if (!canRelog() && getConfig().loadUrl.indexOf('otp') < 0) {

      if (!canRelog()) {
        elasticLogEvent({ what: 'noCmdRelog', msg: `canRelog is false, skipping cmd ${updateStrId}.`, updateStrId }, `noCmdRelog:${updateStrId}`);
        return;
      }

      setRelog();
      elasticLogEvent({ what: 'doCmdRelog', msg: `Reloading for updateStrId=${updateStrId}.`, updateStrId });
      setTimeout(() => {
        localStorage.setItem(LOCAL_UPDATE_ID_KEY, this.processedUpdateId); //prevent loop across relaunches
        reloadNoCache();
      }, 1000 * 3); //delay is escape time for logs, and for doppelgangers to process this command ungated by localStorage sentinel
    }, 1000 * (15 + Math.round(Math.random() * 5)));


    const preSnapProducerFunc = () => env.firestore.collection(env.site).doc('general_config');
    this.generalConfigListener = refreshedSnapshot('general_config', preSnapProducerFunc, undefined, (genConfigDoc) => {
      if (!genConfigDoc.exists) {
        this.updateTarget = undefined;
        return;
      }
      let genConfig = genConfigDoc.data();

      // Preferred Elastic creds are sent from MBot backend, but we are preserving net_config as a fallback
      let config = getConfig();
      if (!areSame(config.firestoreElastic, genConfig.net_config)) {
        setConfig({ ...config, firestoreElastic: genConfig.net_config });
      }

      if (genConfig.firestoreRefreshMinutes !== undefined) {
        let config = getConfig();
        if (genConfig.firestoreRefreshMinutes != config.firestoreRefreshMinutes)
          setConfig({ ...config, firestoreRefreshMinutes: genConfig.firestoreRefreshMinutes });
      }

      if (!areSame(genConfig.svcAvailCfg, this.state.svcAvailCfg)) {
        this.setState({ svcAvailCfg: genConfig.svcAvailCfg });

        let svcsUp = !this.showSvcsDown(genConfig.svcAvailCfg);
        logSetSvcsUp(svcsUp);
      }

      if(!areSame(this.state.stationHours, genConfig.stationHours)) {
        this.setState({stationHours:genConfig.stationHours});
      }

      if(!areSame(this.state.rechimes, genConfig.rechimes)) {
        this.setState({rechimes:genConfig.rechimes});
      }

      if(!areSame(this.state.autoPrioConfig, genConfig.autoPrioConfig)) {
        getShared().autoPrioConfig = genConfig.autoPrioConfig;
        this.setState({autoPrioConfig:genConfig.autoPrioConfig});
      }

      this.loiterConfig =
        genConfig.loiterConfig && genConfig.loiterConfig.doorIds.length ? genConfig.loiterConfig : undefined;
      if (this.loiterConfig) {
        //tack on defaults if not provided
        this.loiterConfig.deadSpan = this.loiterConfig.deadSpan || 10;
        this.loiterConfig.remindSpan = this.loiterConfig.remindSpan || 60 * 2;
        this.loiterConfig.slideLoopSpan = this.loiterConfig.slideLoopSpan || 6;
      }

      //service updates if they exist
      let updateField = (genConfig || {}).update;

      setReloadTimeStr((updateField || {}).target);
      if (!updateField) return;

      let v1UpdateRec = updateField.v1;
      if (!v1UpdateRec) return;
      if (!v1UpdateRec.id) return elasticLogEvent({ what: 'cmdInterp', msg: `Missing .id field` }, `updateNoId`);
      if (!v1UpdateRec.steps) return elasticLogError({ what: 'cmdInterp', msg: `Missing .steps field` }, `updateNoSteps`);
      if(typeof(v1UpdateRec.steps) != 'string' && !Array.isArray(v1UpdateRec.steps))
        return elasticLogError({ what: 'cmdInterp', msg: `Bad steps field type=${typeof(v1UpdateRec.steps)}` }, `updateBadSteps`);

      this.updateRec = v1UpdateRec;
    });
  }


  /*
    Returning undefined means there's no need to block or warn.
    
    A station not having any record means it's always open.
    A given day not having any record means it's open all that day.

    userChoices will be returned falsey if the station choice is disallowed;
    else userChoices will be of form {yes:string, no:string}, where those
    strings are button labels that will be presented to the user, and
    hitting the yes button will go ahead with the operation anyhow, and
    the no button will stop the process and allow the user to choose a
    different station.

    This routine 
      * presumes that in a given day record, .open will precede .closed.
      * does not provide for more than a single span of open-ness on a given day.
      * does not attempt midnight boundary management.

    stationHours sample config:

      {
        pathology_receiving: {
          earlyBlock:45,                //45 minutes is too far before opening
          earlyWarn:15,                 //15 minutes is worryingly far before opening, but user's choice
          lateWarn:45,                  //45 minutes is worryingly close to closing, but user's choice
          lateBlock:15,                 //15 minutes is too close to closing
          alt: 'blood_bank',
          schedule: [
            {closedAllDayBlock:true},
            {open:'7:30', closed:'17:00'},
            {open:'7:30', closed:'17:00'},
            {open:'7:30', closed:'17:00'},
            {open:'7:30', closed:'17:00'},
            {open:'7:30', closed:'17:00'},
            {closedAllDayAllow:true},
          ]
        }
      }

  */
  getOpenHoursInfo(stationCode) {
    let {stationHours} = this.state;

    if(!stationHours) return;
    let stationEntry = stationHours[stationCode];
    if(!stationEntry?.schedule) return;
    if(
      !stationEntry.earlyBlock && 
      !stationEntry.earlyWarn && 
      !stationEntry.lateBlock && 
      !stationEntry.lateWarn
    ) return;

    const curDate = new Date();



    let dow = curDate.getDay();
    let daySchedule = stationEntry.schedule[dow];
    if(!daySchedule) return;

    const now = Date.now();

    const getHMTicks = (h, m) => {
      let d = new Date();
      d.setHours(h);
      d.setMinutes(m);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d.getTime();
    };

    const yes = 'Yes, ignore schedule', no = `No, I'll change it`;

    const stationFriendly = r2h(stationCode), altStationFriendly = stationEntry.alt ? (r2h(stationEntry.alt) + ' instead') : 'some other station';

    if(daySchedule.closedAllDayBlock || daySchedule.closedAllDayAllow || !daySchedule.open) {
      if(daySchedule.closedAllDayBlock) {
        return { msg: `${stationFriendly} is closed today, please send to ${altStationFriendly}.`};
      }
      else {
        return { 
          msg: `${stationFriendly} is closed today, it's recommended that you send to ${altStationFriendly}. Continue with current station anyhow?`, 
          userChoices: {yes, no}
        };
      }

    }


    let openTicks = getHMTicks(...daySchedule.open.split(':').map(n => Number(n || 0)));
    if(now < openTicks) {
      let minsBeforeOpen = (openTicks - now) / (1000 * 60);
      if(stationEntry.earlyBlock && minsBeforeOpen > stationEntry.earlyBlock) {
        return { msg: `${stationFriendly} doesn't open until ${getHrsMinsAmpmStr(openTicks)}, please send to ${altStationFriendly}.`};
      }
      if(stationEntry.earlyWarn && minsBeforeOpen > stationEntry.earlyWarn) {
        return { 
          msg: `${stationFriendly} doesn't open until ${getHrsMinsAmpmStr(openTicks)}, it's recommended that you send to ${altStationFriendly}. Continue with current station anyhow?`, 
          userChoices: {yes, no}
        };
      }

      return; //no need to warn or block

    }

    if(!daySchedule.closed)
      return;

    let closedTicks = getHMTicks(...daySchedule.closed.split(':').map(n => Number(n || 0)));
    let minsTilClose = (closedTicks - now) / (1000 * 60);
    let whenVerb = minsTilClose > 0 ? 'is closing at' : 'closed at';
    if(stationEntry.lateBlock && minsTilClose < stationEntry.lateBlock) {
      return { msg: `${stationFriendly} ${whenVerb} ${getHrsMinsAmpmStr(closedTicks)}, please send to ${altStationFriendly}.`};
    }
    if(stationEntry.lateWarn && minsTilClose < stationEntry.lateWarn) {
      return { 
        msg: `${stationFriendly} ${whenVerb} ${getHrsMinsAmpmStr(closedTicks)}, it's recommended that you send to ${altStationFriendly}. Continue with current station anyhow?`,
        userChoices: {yes, no}
      };
    }
  }


  getBatchAssist() {
    return true;
  }

  showReloadScreen(cb) {
    let iffyTimeout = setTimeout(() => {
      this.setState({ showReloadScreen: { ...this.state.showReloadScreen, iffy: true } });
    }, 5000);

    this.setState({ showReloadScreen: { cb, netTestStart: Date.now(), iffyTimeout } }, () => {
      //start network test
      const setNetResult = (netResult) =>
        this.setState({ showReloadScreen: { ...this.state.showReloadScreen, netResult } });
      fetchConf({
        success: (json) => setNetResult('good'),
        bad: () => setNetResult('bad'),
        badJson: () => setNetResult('json'),
      });
    });
  }

  /**
   * Updates state for kioskSettings and allKioskSettings
   *
   * @param {Array|object} settings - Array of all kiosk settings or an object containing current kiosk settings
   * @param {string} kioskName - Name of the current kiosk
   */
  handleKioskSettingsData(settings, kioskName) {
    if (settings) {
      if (Array.isArray(settings)) {
        // Inital data load for all kiosks
        this.setState({ allKioskSettings: settings });

        // Set state for current kiosk
        const kiosk = settings.find((k) => k.name == kioskName);
        if (kiosk) this.setState({ kioskSettings: kiosk });
      }
      else {
        // Socket update current kiosk
        const isCurrentKiosk = settings.name == kioskName;
        if (isCurrentKiosk) this.setState({ kioskSettings: settings });

        // Update current kiosk in all kiosks array
        const allKioskSettings = this.state.allKioskSettings.slice();
        const kioskIdx = allKioskSettings.findIndex((k) => k.id == settings.id);
        if (kioskIdx >= 0) {
          allKioskSettings[kioskIdx] = settings;
          this.setState({ allKioskSettings });
        }
      }
    }
  }

  /**
   * Adds a kiosk to kiosk settings.
   * @param {object} kiosk - An object containing current kiosk details
   */
  handleAddKiosk(kiosk) {
    const settings = this.state.allKioskSettings;

    if (kiosk) settings.push(kiosk);

    this.setState({ allKioskSettings: settings });
  }

  /**
   * Removes a kiosk from kiosk settings.
   * @param {object} kiosk - An object containing current kiosk details
   */
  handleDeleteKiosk(kiosk) {
    const settings = this.state.allKioskSettings.filter((k) => k.id !== kiosk.id);

    if (settings.length)          //250315 LMR asks: why is this condition here? shouldn't we set it even if now empty?
      this.setState({ allKioskSettings: settings });
  }


  getEnabledKioskFriendlyNames() {
    let allKioskSettings = this.state.allKioskSettings;
    if(!allKioskSettings) return [];

    return (getsIdsMoxspotNames()).filter(kiosk => {
      const friendlyName = h2r(kiosk);
      const currentKiosk = allKioskSettings.find(k => k.name == friendlyName);
      return !!getSettingValue(currentKiosk, KIOSK_SETTINGS.Available);
    });
  }


  componentDidMount() {
    const { settingsSocket } = this.props;
    setLoadScreenShowFunc(this.showReloadScreen);

    let robotId = getRobotId();

    //250430 setTimeout(() => this.clickPlay('peal'), 500); //audio feedback; slight delay arbitrary / hedgy

    if (!robotId)
      //this 'if' fixes OD-131 by not showing unavailable hours on robot kiosk
      this.serviceAvailabilityCheck = setInterval(() => this.checkServiceAvailable(), CHECK_SERVICE_AVAILABLE_INTERVAL);

    this.initAutoUpdateListeners();

    if (robotId) {
      this.stepStatusSubscription = subscribeStepStatus((stepStatus) => {
        //{task_uuid, task_type, step_type, task_args: {start_goal, end_goal}}
        if (!areSame(this.state.stepStatus, stepStatus) || !this.statusInited) {
          this.statusInited = true;

          let moxiCurrentAction = ROBOT_IDLE_STATE;
          if (stepStatus && stepStatus.task_type) {
            moxiCurrentAction = this.getMoxiCurrentActionString(
              stepStatus.task_type,
              stepStatus.step_type,
              stepStatus.get_arg_values(),
            );
          }

          //update the displayed robot status
          let actionsAndStatuses = {};
          actionsAndStatuses[robotId] = { moxiCurrentAction };
          this.setState({ actionsAndStatuses, stepStatus, moxiCurrentAction });

          //figure out whether we need to show/hide a load/unload screen
          let viewToShow;
          if (stepStatus) viewToShow = { load_tube: LoadScreen, unload_tube: UnloadScreen }[stepStatus.step_type];
          if (!viewToShow) this.closeModal();
          else this.presentModal(viewToShow);
        }
      });
      this.socialCueSubscription = subscribeSocialCue((socialCue) => {
        if (socialCue !== this.state.textDisplay) {
          this.setState({
            showTextDisplay: !!socialCue,
            textDisplay: socialCue,
          });
        }
      });
    }

    if (robotId)
      this.estopSubscription = subscribeEstop((aggregated_estop_state) => this.monitorEStops(aggregated_estop_state));

    this.taskUnsubscribe = taskSubscribe((tasks) => this.handleTasks(tasks));

    const scheduler_id = 'scheduler0';
    let taskBoardFunc = () => env.firestore.doc(`${env.site}/schedulers/${scheduler_id}/task_board`);
    this.queueUnsubscribe = refreshedSnapshot('task_board', taskBoardFunc, undefined, (doc) => {
      const task_board = doc.data();
      if (!task_board) {
        return;
      }

      let simple_queues = {};
      for (const qid in task_board.queues) {
        const q = task_board.queues[qid];
        let task_uuids = q.tasks.map((task_ref) => {
          return task_ref.uuid;
        });
        simple_queues[qid] = task_uuids;
      }

      let simple_board = {
        version_stamp: task_board.version_stamp,
        queues: simple_queues,
        robots_tasks: task_board.robots_tasks,
      };

      this.manageRobotRecs(Object.keys(simple_queues).filter((qName) => qName != 'triage'));

      this.handleQueues(simple_board);
    });

    // Subscribe to 'devices' for kiosk chime
    let devicesFunc = () => env.firestore.collection(`${env.site}/argument_types/devices`);
    this.devicesUnsubscribe = refreshedSnapshot('devices', devicesFunc, undefined, async (deviceCollection) => {
      let kioskKey;
      kioskKey = getUnitWp();
      deviceCollection.docs.forEach((device) => {
        if (device.id == kioskKey) {
          const chimeData = device.data().chime;
          if (chimeData) {
            env.handleChimeRequest(chimeData.timestamp, () => this.clickPlay(arrivalSoundName));
            return; //TODO: remove this, it does nothing, riiiiiiight?
          }
        }
      });
    });

    let mgmtTriggerFunc = () => env.firestore.collection(env.site).doc('dvcMgmtTrigger');
    this.spurListener = refreshedSnapshot('dvcMgmtTrigger', mgmtTriggerFunc, undefined, spur => {
      if(!spur) return;
      if(!spur.exists) return;
      spur = spur.data();
      hallpassHandleSpur(spur);
    });

    window.addEventListener('resize', this.handleDimensionChange);
    this.setState({ tall: isTall() });

    if (getConfig().kioskSettings) {
      if (settingsSocket.connected) {
        console.log(`Connected to socket on multibot backend.`);
      }
      settingsSocket.on('connect', () => {
        console.log(`Connected to socket on multibot backend.`);
        initKioskSettings(
          settingsSocket,
          (kioskSettings) => this.handleKioskSettingsData(kioskSettings, getUnitWp(true)),
          (kioskSettings) => this.handleAddKiosk(kioskSettings),
          (kioskSettings) => this.handleDeleteKiosk(kioskSettings),
        );
      });
      settingsSocket.on('disconnect', () => {
        console.log(`Disconnected from socket on multibot backend.`);
      });

      initKioskSettings(
        settingsSocket,
        (kioskSettings) => this.handleKioskSettingsData(kioskSettings, getUnitWp(true)),
        (kioskSettings) => this.handleAddKiosk(kioskSettings),
        (kioskSettings) => this.handleDeleteKiosk(kioskSettings),
      );
    }

    this.changeIdInterval = setInterval(() => this.setState({ changeId: this.state.changeId + 1 }), 1000 * 3);

    if (!getRobotId()) this.loiterInterval = setInterval(() => this.manageLoiterState(), CHECK_DOOR_HELP_INTERVAL);

    if (!getAudioPrimed()) this.setFunFact();

    startHallpassCheckLoop();

    this.moxiState = {lastSent:0}
    this.pollAllListener = subscribePollAll(pollResult => this.serviceMoxiState(pollResult));


    this.priorSoundHeartbeatTicks = Date.now();
    this.soundHeartbeatInterval = setInterval(() => this.soundHeartbeat(), 1000 * 30);

    Audio.init();
  }


  // periodic play-silent-sound heartbeat (exploring mitigations of silent kiosks)
  soundHeartbeat() {
    let soundLoopMins = getShared().autoPrioConfig?.soundLoopMins || 0;
    if(!soundLoopMins) return;

    const now = Date.now();
    if(now - this.priorSoundHeartbeatTicks >= 1000 * 60 * soundLoopMins) {
      this.priorSoundHeartbeatTicks = now;
      elasticLogEvent({what:'soundHeartbeat', msg:`Playing sound heartbeat`});
      this.clickPlay('unsilence');
    }
  }

  componentWillUnmount() {

    if(this.pollAllListener) {
      this.pollAllListener();
      this.pollAllListener = undefined;
    }

    this.unmounting = true;

    stopHallpassCheckLoop();

    this.clearEstopState();

    setLoadScreenShowFunc(undefined);


    if (this.generalConfigListener) {
      this.generalConfigListener();
      this.generalConfigListener = undefined;
    }

    if (this.loiterInterval) {
      clearInterval(this.loiterInterval);
      this.loiterInterval = undefined;
    }

    if(this.soundHeartbeatInterval) {
      clearInterval(this.soundHeartbeatInterval);
      this.soundHeartbeatInterval = undefined;
    }

    if (this.changeIdInterval) {
      clearInterval(this.changeIdInterval);
      this.changeIdInterval = undefined;
    }

    if (this.updateInterval) {
      clearInterval(this.updateInterval);
      this.updateInterval = undefined;
    }

    if (this.ciColorCheck) {
      clearInterval(this.ciColorCheck);
      this.ciColorCheck = undefined;
    }

    // clearRobotHandler();
    unsubscribe(this, 'spurListener');
    unsubscribe(this, 'devicesUnsubscribe');
    unsubscribe(this, 'queueUnsubscribe');
    unsubscribe(this, 'taskUnsubscribe');
    unsubscribe(this, 'stepStatusSubscription');
    unsubscribe(this, 'estopSubscription');
    unsubscribe(this, 'socialCueSubscription');

    window.removeEventListener('resize', this.handleDimensionChange);
  }


  //this gets called per pollAll, i.e. ~ every second.
  serviceMoxiState(pollResult) {
    let moxiId = getRobotId();
    if(!moxiId) return; //we're not in robot mode, do nothing

    const now = Date.now();

    let {tubes, step_status:stepStatus} = pollResult;
    if(tubes) {
      tubes = {...tubes};
      delete tubes.robot_time;
    }
    let curData = {tubes, stepStatus};

    if(!areSame(curData, this.moxiState.curData)) {
      this.moxiState.curData = curData;
      this.moxiState.updated = now;
    }

    //if there's an unresolved outstanding network call already,
    // don't redundantly attempt to send.
    if(this.moxiState.sending) {
      let gapTicks = now - this.moxiState.sending;
      if(gapTicks < 1000 * 60 * 3)  //3m ~ http timeout
        return;  //let the prior net write shake out

      elasticLogError({what:'svcMxStateTO', msg:`Overriding presumed timeout of moxiState sent ${Math.round(gapTicks/1000)}s ago`});
      this.moxiState.sending = undefined; //we're going to override due to timeout
    }

    let gapTicks = 1000 * 30;  //how often to send even if nothing has changed
    if(this.moxiState.lastSent < this.moxiState.updated)
      gapTicks = 1000 * 3; //max frequency to send when things do change

    if(now < this.moxiState.lastSent + gapTicks) return;
    this.moxiState.lastSent = now;
    this.moxiState.sending = now;

    //async
    let options = {
      method: 'PUT',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({moxiId, tubes, stepStatus, updated:this.moxiState.updated})
    }
    let timeoutTicks;
    if(this.state.autoPrioConfig?.moxiStateNetTimeout)
      timeoutTicks = this.state.autoPrioConfig.moxiStateNetTimeout * 1000;
    clearFetch(`${getConfig().uiSimServer}/moxiState`, options, {
      success: (json) => {
        this.moxiState.sending = undefined;
      },
      bad: ({ logStr }) => {
        this.moxiState.sending = undefined;
        if (allowMulti('moxiStateNetErr', 1, 20))
          elasticLogError({ what: 'moxiStateSnd', msg: `Error sending moxiState: ` + logStr })
      }
    }, timeoutTicks);
  }



  manageRobotRecs(robotIds) {
    let robotRecs = this.state.robotRecs;
    let changed = false;

    //remove newly-gone robots
    Object.keys(this.robotSubs).forEach((robotId) => {
      if (robotIds.indexOf(robotId) < 0) {
        this.robotSubs[robotId]();
        delete this.robotSubs[robotId];
        delete robotRecs[robotId];
        changed = true;
      }
    });
    if (changed) {
      this.setState({ robotRecs: { ...robotRecs } });
      if (isKiosk()) this.updateKioskStatus(robotRecs);
    }

    //add newly-appeared robots
    robotIds.forEach((robotId) => {
      if (this.robotSubs[robotId]) return; //we already know about it
      const pollMgrKey = `robot:${robotId}`;
      PollMgrRegister(pollMgrKey, () =>
        refreshedSnapshot(
          `robot:${robotId}`,
          () => env.firestore.collection(`${env.site}/robots/${robotId}`).doc('robot_state'),
          { includeMetadataChanges: true },
          (doc) => {
            let robotRec = doc.data();
            if (!robotRec) return;

            let { current_action_info, user_requests } = robotRec;

            if (!areSame(robotRec, this.state.robotRecs[robotId])) {
              let robotRecs = { ...this.state.robotRecs };
              robotRecs[robotId] = robotRec;
              this.setState({ robotRecs });
              if (isKiosk()) this.updateKioskStatus(robotRecs);

              if (!getRobotId()) this.listenForLoitering(robotId, robotRec);
            }
          },
        ),
      );
      this.robotSubs[robotId] = () => PollMgrUnregister(pollMgrKey);
    });
  }

  monitorEStops(aggregated_estop_state) {
    let hardware = aggregated_estop_state?.hardware_estop;
    let hardwareValue = !!hardware?.value;

    let timestamp = hardware?.timestamp;
    if (timestamp && Date.now() - new Date(timestamp).getTime() > 1000 * 15) hardwareValue = false;

    if (!this.state.estop && hardwareValue) {
      this.setState({
        estop: {
          bang: true,
          interval: setInterval(() => {
            this.setState({ estop: { ...this.state.estop, bang: !this.state.estop.bang } });
          }, 1000),
        },
      });
      elasticLogEvent({ what: 'estopStart', msg: `Estop started` });
    }
    else if (this.state.estop && !hardwareValue) {
      this.clearEstopState();
      elasticLogEvent({ what: 'estopStop', msg: `Estop went away` });
    }
  }

  clearEstopState() {
    if (this.state.estop) {
      clearInterval(this.state.estop.interval);
      this.setState({ estop: undefined });
    }
  }

  robotWantsKioskHelp(robotRec) {
    //quick prelim checks
    if (!this.loiterConfig?.doorIds?.length) return; //no doors at this site are loiter-enabled
    if (!isKiosk()) return; //this station isn't a kiosk

    //see if the robot wants help
    let { current_action_info, user_requests } = robotRec;
    if (!current_action_info || !user_requests) return;

    let { type, args } = current_action_info;
    if (type != 'gothroughdoor' || !args?.doorway_id || this.loiterConfig.doorIds.indexOf(args.doorway_id) < 0) return; //unit0_to_pharmacy

    let personDetection = user_requests['Person Detection'];
    if (!personDetection) return;

    let { created, updated } = personDetection;
    if (!created || !updated) return; //.updated will initially be set simultaneously when .created is

    let createdTicks = 1000 * created.seconds,
      updatedTicks = 1000 * updated.seconds;

    if (Date.now() - updatedTicks > 1000 * this.loiterConfig.deadSpan) return; //dead man's switch (updatedTicks is updated at 0.5hz = every 2 seconds)

    //see if it's this kiosk that the robot is currently headed to
    if (!robotRec.current_task) return; //robot has no current task
    const task = this.tasks.find((t) => t.uuid == robotRec.current_task);
    if (!task || task.task_type != securePt2Pt) return;
    const stepIdx = task.current_step ? task.steps.findIndex((s) => s == task.current_step) : -1;
    const unit = getUnitWp();
    if (
      !(stepIdx == 0 && task.task_level_args.start_goal.value == unit) &&
      !(stepIdx == 2 && task.task_level_args.end_goal.value == unit)
    )
      return; //not headed to this kiosk

    //the robot wants help from this kiosk
    return { createdTicks, updatedTicks };
  }

  listenForLoitering(robotId, robotRec) {
    let doorLoiter = this.state.doorLoiter;
    if (doorLoiter && doorLoiter.robotId != robotId) return; //one at a time, boys

    let newTimes = this.robotWantsKioskHelp(robotRec);

    if (!newTimes) {
      if (doorLoiter) this.setState({ doorLoiter: undefined }); //stop loitering
      // console.log(`debug ${robotId} doesn't wan't help`);
    }
    else {
      //robot is loitering
      // console.log(`debug ${robotId} is loitering`);

      if (!doorLoiter || doorLoiter.createdTicks != newTimes.createdTicks)
        this.manageLoiterState({ robotId, ...newTimes }); //start loitering
      else if (newTimes.updatedTicks != doorLoiter.updatedTicks) this.manageLoiterState({ ...doorLoiter, ...newTimes }); //update loitering
    }
  }

  /* This is called in two contexts:
      1. When related robot state changes, with newLoiterState defined, and
      2. on an interval/loop, with newLoiterState undefined.
  */
  manageLoiterState(newLoiterState) {

    this.serviceKioskChimes();  //to be called periodically

    let doorLoiter = newLoiterState || this.state.doorLoiter;
    if (!doorLoiter) return; //we're neither hearing of a robot rec change nor maintaining an existing interaction

    doorLoiter = { ...doorLoiter };

    const now = Date.now(),
      halfSecond = 500;

    if (now - doorLoiter.updatedTicks > 1000 * this.loiterConfig.deadSpan) {
      // console.log('debug deadSpan kicking in ' + Math.round((now - doorLoiter.updatedTicks)/100)/10 + ' ' + new Date(doorLoiter.updatedTicks))
      this.setState({ doorLoiter: undefined }); //stop loitering
      return;
    }

    let doSlide = false,
      doChime = false;

    if (!this.state.doorLoiter) {
      //newly showing
      // console.log('debug showing new ' + new Date(doorLoiter.dismissedTicks))
      doSlide = true;
      doChime = true;
    }
    else if (
      doorLoiter.dismissedTicks &&
      now - doorLoiter.dismissedTicks >= 1000 * this.loiterConfig.remindSpan - halfSecond
    ) {
      //we were loitering before, got dismissed, and the dismissal has timed out
      // console.log('debug refresh per time since dismiss ' + Math.round((now - doorLoiter.dismissedTicks)/100)/10 + ' ' + new Date(doorLoiter.dismissedTicks))
      doSlide = true;
      doChime = true;
    }
    else if (
      doorLoiter.refreshedTicks &&
      now - doorLoiter.refreshedTicks >= 1000 * this.loiterConfig.slideLoopSpan - halfSecond
    ) {
      //Time to redo the slide animation
      // console.log('debug refresh per time since last refresh ' + Math.round((now - doorLoiter.refreshedTicks)/100)/10 + ' ' + new Date(doorLoiter.refreshedTicks));
      doSlide = true;
      if (now - (doorLoiter.chimedTicks || 0) > 1000 * this.loiterConfig.remindSpan - halfSecond) {
        doChime = true;
      }
    }
    else if (doorLoiter.refreshedTicks) {
      if (now - (doorLoiter.chimedTicks || 0) > 1000 * this.loiterConfig.remindSpan - halfSecond) {
        doChime = true;
      }
    }

    if (doChime) {
      doorLoiter.chimedTicks = now;
      this.clickPlay('noise');
    }

    if (doSlide) {
      doorLoiter.refreshedTicks = now;
      delete doorLoiter.dismissedTicks;
      doorLoiter.left = '100%'; //slide; start at the right
      doorLoiter.transition = undefined;
    }

    const adjustLeft = () => {
      setTimeout(() => {
        if (!this.state.doorLoiter) return; //something cleared it before we got here
        this.setState({ doorLoiter: { ...this.state.doorLoiter, left: 0, transition: `left 0.5s ease-in-out 0.3s` } }); //transition to the actual left
      }, 20);
    };

    this.setState({ doorLoiter }, doSlide ? adjustLeft : undefined);
  }

  dismissDoorHelp() {
    if (!this.state.doorLoiter) return;
    this.setState({ doorLoiter: { ...this.state.doorLoiter, dismissedTicks: Date.now(), refreshedTicks: undefined } });
  }

  handleDimensionChange(event) {
    this.setState({ tall: isTall() });
  }

  handleTasks(tasks) {
    this.tasks = tasks;
    this.makeTaskQueues();
  }

  handleQueues(queues) {
    this.queues = queues.queues;
    this.robots_tasks = queues.robots_tasks;
    this.makeTaskQueues();
  }

  makeTaskQueues() {
    let taskQueues = {};
    if (this.queues && this.tasks) {
      Object.keys(this.queues).forEach((k) => {
        let tasks = this.queues[k].map((uuid) => this.tasks.find((t) => t.uuid == uuid)).filter((t) => t);
        taskQueues[k] = tasks;
      });
    }

    this.setState({ taskQueues });
  }

  /**
   * Checks whether our service is available at the moment
   *  and presents the serviceunavailablescreen when it's outside our hours of operation
   */
  checkServiceAvailable() {
    const isServiceAvailable = true;  //env.siteConfig.checkServiceAvailabilityNow(getDeliveryType());
    if (!isServiceAvailable) this.presentModal(ServiceUnavailableScreenNoButton);
    else if ((this.state.modalScreen || {}).viewName == ServiceUnavailableScreenNoButton.viewName) this.closeModal();
  }

  presentModal(nextScreen) {
    if (!this.state.modalScreen || nextScreen.viewName !== this.state.modalScreen.viewName) {
      this.setState({ modalScreen: nextScreen });
    }
  }

  closeModal(showError) {
    this.setState({ modalScreen: undefined });

    if (showError) {
      let errorPrompt = ERROR_PROMPT.default;
      if (typeof showError == 'object') {
        errorPrompt = showError;
        showError = true;
      }
      this.setState({ showError, errorPrompt });
    }
  }

  /**
   * Displays an error message arising from a reorder operation.
   *
   * @param .code (int) - a number that can be reported in case dev-level debugging is
   *    required.  Can be undefined/0.
   * @param .message (string) - a user-readable string indicating what type of error occurred.
   */
  setReorderError({ code, message }) {
    let title = 'Reorder failed';
    if (code) title += ` (code=${code})`;
    this.setState({ showError: true, errorPrompt: { title, message } });
  }

  getTravelToString = (taskAttribute, task) => {
    let untemplatedStatus = getUntemplatedStatus(task.task_type);
    if (untemplatedStatus) {
      return untemplatedStatus;
    }

    let taskArg = task.task_level_args[taskAttribute];
    if (!taskArg || !taskArg.value) {
      return getUntemplatedStatus(undefined) || ROBOT_IDLE_STATE;
    }

    const destination = r2h(taskArg.value);
    return `Traveling to ${destination}`;
  };

  getMoxiCurrentActionString(taskType, stepType, taskArgs) {
    if (!taskType) return ROBOT_IDLE_STATE;

    let untemplatedStatus = getUntemplatedStatus(taskType);
    if (untemplatedStatus) return untemplatedStatus;

    //scheduler-created gotos have only an end_goal
    if (taskType == 'go_to' || taskType == 'go_to_charger') {
      let friendlyName = r2h(taskArgs.start_goal || taskArgs.end_goal);
      if (friendlyName) return `traveling to ${friendlyName}`;
      else return 'on the move';
    }

    switch (stepType) {
      case 'goto':
        return `Traveling to ${r2h(taskArgs.start_goal)}`;
      case 'load_tube':
        return `Loading Delivery`;
      case 'secure_goto':
        return `Traveling to ${r2h(taskArgs.end_goal)}`;
      case 'unload_tube':
        return `Unloading Delivery`;
      case 'dock_with_charger':
        return `Docking with charger`;
      case 'undock_from_charger':
        return `Undocking from charger`;
    }
    console.log('getMoxiCurrentActionString called with uncased stepType: ' + stepType);
    return ROBOT_IDLE_STATE;
  }

  getMoxiCurrentActionStringV2(taskType, stepType, taskArgs, stepIdx) {
    if (!taskType) return ROBOT_IDLE_STATE;

    let untemplatedStatus = getUntemplatedStatus(taskType);
    if (untemplatedStatus) return untemplatedStatus;

    //scheduler-created gotos have only an end_goal
    if (taskType == TASK_TYPE.NAVIGATION || taskType == TASK_TYPE.CHARGE) {
      let friendlyName = r2h(taskArgs.start_goal || taskArgs.end_goal);
      if (friendlyName) return `traveling to ${friendlyName}`;
      else return 'on the move';
    }

    switch (stepType) {
      case 'goto':
        return stepIdx == 0 ? `Traveling to ${r2h(taskArgs.start_goal)}` : `Traveling to ${r2h(taskArgs.end_goal)}`;
      case 'load_tube':
        return `Loading Delivery`;
      case 'secure_goto':
        return `Traveling to ${r2h(taskArgs.end_goal)}`;
      case 'unload_tube':
        return `Unloading Delivery`;
      case 'dock_with_charger':
        return `Docking with charger`;
      case 'undock_from_charger':
        return `Undocking from charger`;
      default:
        console.log('getMoxiCurrentActionString called with uncased stepType: ' + stepType);
        return ROBOT_IDLE_STATE;
    }
  }

  getActionStringParams(task) {
    let { stepType, stepIdx } = getCurrentView(task);

    let taskLevelArgs = {};

    if (task.task_level_args.start_goal) {
      taskLevelArgs['start_goal'] = task.task_level_args.start_goal.value;
    }
    if (task.task_level_args.end_goal) {
      taskLevelArgs['end_goal'] = task.task_level_args.end_goal.value;
    }
    return { stepType, taskLevelArgs, stepIdx };
  }



  serviceKioskChimes(robotRecs) {

    if(getRobotId()) return;  //robot chimes are handled in LoadScreen and UnloadScreen

    robotRecs = robotRecs || this.state.robotRecs;
    if(!robotRecs) return;

    const waypoint = getUnitWp();
    const now = Date.now();

    Object.keys(robotRecs).forEach((robotId) => {
      let r = robotRecs[robotId];
      let task;
      if (r.current_task) task = this.tasks.find((t) => t.uuid == r.current_task);
      if (!task) return;
      if(task.task_data.test) return; //don't chime on test tasks

      let { stepType, taskLevelArgs, stepIdx } = this.getActionStringParams(task);

      const isLoading = stepType == V1_LOAD_STEP_TYPE;
      const isUnloading = stepType == V1_UNLOAD_STEP_TYPE;

      const pickingUpHere = isLoading && taskLevelArgs.start_goal == waypoint;
      const droppingOffHere = isUnloading && taskLevelArgs.end_goal == waypoint;

      if (!pickingUpHere && !droppingOffHere) return;

      //todo: could consider not chiming on unneeded phase of cc task

      // Suppress chime on unneeded phase of batch task
      if(task.task_data.batch) {
        let { batchType, index, total } = task.task_data.batch;
        if (
          (isLoading && batchType == ONE_TO_MANY && index > 0) ||
          (isUnloading && batchType == MANY_TO_ONE && index < total - 1)
        ) {
          return;
        }
      }


      //we've now determined that we're in a phase for which we chime, possibly at intervals

      // rechimes:{
      //   defaultSecs:60 * 3, can be absent/undefined,
      //   stations:{nicu:-1, lab:-1, or:20 /*all:-1*/}
      // }

      // Check if drawer state confidence is low, if so do not rechime
      let chimeEnabled = !r.drawer_confidence || (r.drawer_confidence.confidence_level == DRAWER_CONFIDENCE.HIGH);
      let rechimeSeconds;
      if(this.state.rechimes) {
        let {defaultSecs, stations} = this.state.rechimes;

        //hard defaults
        stations = stations || {};
        defaultSecs = defaultSecs || 60 * 3;

        rechimeSeconds = stations[waypoint] || stations['all'];
        if(rechimeSeconds && rechimeSeconds < 0)
          rechimeSeconds = defaultSecs;
      }

      const taskStepKey = `${stepType}:${task.uuid}`;

      const lastChimedTicks = this.chimeTable[taskStepKey];
      if(chimeEnabled && (!lastChimedTicks || (rechimeSeconds && (now - lastChimedTicks >= rechimeSeconds * 1000)))) {
        this.chimeTable[taskStepKey] = now;
        let msg = !lastChimedTicks ? `Chiming kiosk ${waypoint} (first)` : `Re-chiming kiosk ${waypoint} after ${rechimeSeconds} secs`;
        elasticLogEvent({ what: 'kioskReChime', msg, waypoint: waypoint });
        this.clickPlay(arrivalSoundName);
      }

    });


    //prune chimeTable: toss out entries older than three hours
    Object.keys(this.chimeTable).forEach((key) => {
      if (now - this.chimeTable[key] > 1000 * 60 * 60 * 3) delete this.chimeTable[key];
    });
  }




  //play chime if load/unload, and calculate rolled-up status of all robots
  updateKioskStatus(robotRecs) {
    let waypoint = getUnitWp();
    let actionsAndStatuses = {};
    let unrelatedTaskCount = 0;
    let relatedTaskCount = 0;

    Object.keys(robotRecs).forEach((robotId) => {
      let r = robotRecs[robotId];
      let task;
      if (r.current_task) task = this.tasks.find((t) => t.uuid == r.current_task);

      if (task) {
        let { stepType, taskLevelArgs, stepIdx } = this.getActionStringParams(task);

        if (this.showUnrelated() || (!this.showUnrelated() && this.isRelated(task)))
          actionsAndStatuses[robotId] = { moxiCurrentAction: this.getMoxiCurrentActionString(task.task_type, stepType, taskLevelArgs)};
        else
          actionsAndStatuses[robotId] = { moxiCurrentAction: ROBOT_IDLE_STATE };

        if (this.isRelated(task))
          relatedTaskCount++;
        else
          unrelatedTaskCount++;
      }
      else {
        actionsAndStatuses[robotId] = { moxiCurrentAction: ROBOT_IDLE_STATE };
      }
    });

    //Collapse the statuses down into one.
    let robotId0 = Object.keys(robotRecs)[0];
    if (!robotId0) return;

    if (Object.keys(robotRecs).length > 1) {
      //If any are NOT idle, discard idles.
      let actionStrs = Object.keys(robotRecs).map((robotId) => actionsAndStatuses[robotId].moxiCurrentAction);
      let nonIdleCount = 0;
      actionStrs.forEach((s) => {
        if (s != ROBOT_IDLE_STATE) ++nonIdleCount;
      });
      if (nonIdleCount) actionStrs = actionStrs.filter((s) => s != ROBOT_IDLE_STATE);

      //Discard duplicates.
      let seen = {};
      actionStrs = actionStrs.filter((s) => {
        if (!seen[s]) {
          seen[s] = true;
          return true;
        }
        return false;
      });

      //Conjunct what remains.
      actionsAndStatuses = {};
      actionsAndStatuses[robotId0] = { moxiCurrentAction: actionStrs.join(' and ') };
    }

    // If showUnrelated setting is off and urelated tasks are in progress, show "on the move"
    if (!this.showUnrelated() && unrelatedTaskCount > 0 && relatedTaskCount == 0)
      actionsAndStatuses[robotId0] = { moxiCurrentAction: 'on the move' };

    this.setState({ actionsAndStatuses });

    this.serviceKioskChimes(robotRecs);
  }

  async clickPlay(soundToPlay) {

    if(!getAudioPrimed()) {
      elasticLogEvent({ what: 'prePrimeAudioSkip', msg: `Audio not yet primed, so not playing ${soundToPlay.slice(0, 200)}`});
      return;
    }

    this.soundToPlay = soundToPlay;

    //on initial load it can take a few seconds for things to render
    let start = Date.now();
    while (!this.playerEl || !this.audioClickEl) {
      await sleep(500);
      if (Date.now() - start >= 1000 * 10) break;
    }

    if (this.playerEl && this.audioClickEl) this.audioClickEl.click();
  }

  clickPlayCB() {
    let soundToPlay = this.soundToPlay == briefSilence ? briefSilence : `${this.soundToPlay}.mp3`;
    Audio.playSound(soundToPlay, this.playerEl);
  }

  setShowTextDisplay(show) {
    this.setState({ showTextDisplay: show });
  }

  makeLoadScreen() {
    let { cb, netTestStart, netResult, iffyTimeout, iffy } = this.state.showReloadScreen;

    const finish = (values) => {
      clearTimeout(iffyTimeout);
      this.setState({ showReloadScreen: undefined });
      cb(values);
    };

    let networkStatus = <div style={{ fontStyle: 'italic' }}>Testing...</div>;
    if (netResult == 'good') networkStatus = <div style={{}}>Good</div>;
    else if (netResult == 'bad') networkStatus = <div style={{}}>Error</div>;
    else if (netResult == 'json') networkStatus = <div style={{}}>Bad json</div>;
    else if (iffy) networkStatus = <div style={{ fontStyle: 'italic' }}>Testing...slow...</div>;

    // const offerLoginScreen = getConfig().loadUrl.indexOf('otp') < 0;
    let autoPrioConfig = getShared().autoPrioConfig;
    const offerLoginScreen = autoPrioConfig && !autoPrioConfig.noLegacy;

    return (
      <div
        style={{
          backgroundColor: '#fff',
          display: 'flex',
          flexFlow: 'column',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          ...noTouchAction,
        }}
      >
        <div style={{ display: 'flex', flexFlow: 'row', alignItems: 'center' }}>
          <div style={{ marginRight: 5 }}>Network status:</div>
          {networkStatus}
        </div>
        <span style={{ marginTop: 50, fontSize: 36, fontWeight: 400 }}>Reload To</span>
        <DRButton
          phrase={'Same Unit'}
          action={() => finish({ useSameConfig: true })}
          customizeStyle={{ marginTop: 10 }}
          fontColor={'#000'}
          fillColor={'#FFF'}
          borderColor={'#000'}
        />
        {!!offerLoginScreen && (
          <DRButton
            phrase={'Login Screen'}
            action={() => finish({})}
            customizeStyle={{ marginTop: 10 }}
            fontColor={'#000'}
            fillColor={'#FFF'}
            borderColor={'#000'}
          />
        )}
        <DRButton
          phrase={'Cancel'}
          action={() => finish({ cancel: true })}
          customizeStyle={{ marginTop: 10 }}
          fontColor={'#000'}
          fillColor={'#FFF'}
          borderColor={'#000'}
        />
      </div>
    );
  }

  showSvcsDown(svcAvailCfgParam) {
    if(getRobotId()) return false; //don't affect robots

    let svcAvailCfg = svcAvailCfgParam || this.state.svcAvailCfg;
    if (!svcAvailCfg) return false;

    if (svcAvailCfg.mode == 'upAll') return false;
    if (svcAvailCfg.mode == 'downAll') return true;

    return !!(svcAvailCfg.downStations || {})[getUnitWp()];
  }

  makeSvcsDownScreen() {
    let { svcAvailCfg } = this.state;

    let bannerFontSz = svcAvailCfg.subText && svcAvailCfg.banner.length > 80 ? 50 : 60;

    const cyan = '#2983ad';
    const bgColor = 'white',
      fgColor = cyan;

    return (
      <div
        style={{
          backgroundColor: bgColor,
          display: 'flex',
          flexFlow: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          position: 'relative',
          ...noSelect,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: 30,
            overflowY: 'hidden',
          }}
        >
          <div style={{ fontSize: bannerFontSz, fontWeight: 400, color: fgColor, textWrap: 'balance' }}>
            {svcAvailCfg.banner || `Moxi services are temporarily unavailable.`}
          </div>
          {!!svcAvailCfg.subText && (
            <div style={{ marginTop: 25, fontSize: 36, fontWeight: 200, color: fgColor, textWrap: 'balance' }}>
              {svcAvailCfg.subText}
            </div>
          )}
        </div>

        <div style={{ color: fgColor, position: 'absolute', bottom: 10, backgroundColor: bgColor }}>
          {r2h(getUnitWp())}
        </div>
      </div>
    );
  }

  primeAudio(makeSound) {
    let wasPrimedBefore = getAudioPrimed();
    setAudioPrimed();
    this.clickPlay(briefSilence);
    if (makeSound)
      // && !wasPrimedBefore
      setTimeout(() => this.clickPlay('peal'), 500);
  }

  isRelated(task) {
    const unit = getUnitWp();
    return !!(
      task &&
      task.task_type == securePt2Pt &&
      (task.task_level_args.start_goal.value == unit || task.task_level_args.end_goal.value == unit)
    );
  }

  showUnrelated() {
    const { kioskSettings } = this.state;
    return typeof getSettingValue(kioskSettings, KIOSK_SETTINGS.ShowUnrelated) == 'boolean'
      ? getSettingValue(kioskSettings, KIOSK_SETTINGS.ShowUnrelated)
      : true;
  }

  showRobotsInService() {
    const { kioskSettings } = this.state;
    return typeof getSettingValue(kioskSettings, KIOSK_SETTINGS.ShowRobotsInService) == 'boolean'
      ? getSettingValue(kioskSettings, KIOSK_SETTINGS.ShowRobotsInService)
      : false;  // defaults to off
  }


  setFunFact() {
    this.setState({ funFact: funFacts[Math.floor(Math.random() * funFacts.length)] });
  }


  funFactTapped() {
    this.primeAudio(true);
    this.setState({ funFact: undefined });
  }

  getQueueDescription(displayTasks){
    let description = "(Nothing queued)";
    if (displayTasks.length) {
      let numInProgress = displayTasks.filter((x) => x.inProgress).length;
      let numWaiting = displayTasks.length - numInProgress;
      if (numInProgress || numWaiting) {
        description = numInProgress ? `${numInProgress} in progress` : '';
        if (numWaiting) {
          if (description) description = description + ', ';
          description = description + `${numWaiting} queued`;
        }
      }
    }
    return description;
  }

  getRobotsInService(robotIds){
    let excludedBotsWithReasons = this.state.autoPrioConfig?.excludedBotsWithReasons;
    let excludedBots = Object.keys(excludedBotsWithReasons || {});
    let currentBots = Object.keys(this.state.robotRecs);
    let totalBots = currentBots.length;
    let unavailableBots = 0;
    excludedBots.forEach((bot) => {
      if(currentBots.includes(bot)){
        let reasonsList = Object.keys(excludedBotsWithReasons[bot]?.reasons || {});
        let isOOP = reasonsList.includes('OOP');
        let isSpare = reasonsList.includes('Spare Robot');
        if(isSpare){ 
          totalBots-=1;
        }
        else {
          if(isOOP){
            unavailableBots+=1;
          }
          // don't double-count spares that are marked OOP
        }
      }
      // else: there's a robot entry but the robot is no longer at this site, skip
    });
    return totalBots - unavailableBots;
  }


  render() {

    if (this.showSvcsDown())
      return this.makeSvcsDownScreen();

    if (this.state.showReloadScreen)
      return this.makeLoadScreen();

    if (!this.state.taskQueues)
      return <Loader loading={true} />

    if(this.state.badgeReport) {
      return <BadgeReport 
        station={this.state.badgeReport.station}
        primeAudio={makeSound => this.primeAudio(makeSound)}
        done={() => this.setState({badgeReport:undefined})}
        showNames={!!this.state.autoPrioConfig?.showBadgeReportNamesOnKiosk}
      />
    }

    //if this is a bot on a cc-delivery or cc-unload and we're in the travel-to-dropoff phase, just show One Moment
    if (getRobotId()) {
      let robotRec = this.state.robotRecs[getRobotId()];
      const curTaskId = robotRec?.current_task;
      if (curTaskId) {
        let task = this.tasks.find((t) => t.uuid == curTaskId);
        let ccTask = task?.task_data?.ccTask;
        if(ccTask) {
          const stepIdx = task.current_step ? task.steps.findIndex((s) => s == task.current_step) : -1;
          if(stepIdx == 2) {
            //traveling to dropoff
            return <div
              style={{ backgroundColor: '#fff', display: 'flex', flexFlow: 'column', 
                height: '100vh', alignItems: 'center', justifyContent: 'center', ...noTouchAction }}
            >
              <ThinkingScreen/>
            </div>
          }
        }
      }
    }


    //show tasks in all queues in the following order:
    //  - tasks currently being executed on robots, sorted by robotId
    //  - tasks currently assigned to a robot queue, round-robin interleaved
    //  - tasks in triage
    let displayTasks = [];
    let localRobotId = getRobotId();

    let conditionalQueue = (taskData) => {
      if (!taskData.task) {
        if (allowMulti('nullQTaskCC', 1, 5))
          elasticLogError({ what: 'nullQTask', msg: 'Falsey task fed to conditionalQueue' });
        return;
      }
      let shouldQueue =
        (localRobotId || //we're not a kiosk
          !taskData.task.task_data.test) && //it's not a test task
        !displayTasks.find((dt) => dt.task.uuid == taskData.task.uuid);
      if (shouldQueue) displayTasks.push(taskData);
    };

    let tqs = this.state.taskQueues || {};
    let robotIds = localRobotId ? [localRobotId] : Object.keys(tqs).filter((k) => k != 'triage');
    robotIds.sort();

    //robot current tasks
    let robotHasTask = {};
    robotIds.forEach((robotId) => {
      let robotRec = this.state.robotRecs[robotId];

      if (robotRec) {
        const curTaskId = robotRec.current_task;
        if (curTaskId) {
          let task = this.tasks.find((t) => t.uuid == curTaskId);
          if (task) {
            conditionalQueue({ task, inProgress: robotId });
            robotHasTask[robotId] = true;
          }
          else {
            console.log(`NB: robot ${robotId}'s currentTask ${curTaskId} did not match a known task.`); //TODO remote log?
          }
        }
      }
      else {
        //TODO remote log?
      }
    });

    //for any otherwise idle robots, check whether there's a task transitioning to assignment
    robotIds.forEach((robotId) => {
      let uuid = (this.robots_tasks || {})[robotId];
      if (uuid && !robotHasTask[robotId]) {
        let task = this.tasks.find((t) => t.uuid == uuid);
        let status = ['claimed', 'in_progress', 'request', 'todo'];
        if (!task) {
          if(throttleAllow(`noTaskMatch:${robotId}`))
            console.log(`NB: robot ${robotId}'s currentTask ${uuid} did not match a known task.`);
        }
        else if (status.indexOf(task.status) >= 0) {
          conditionalQueue({ task });
        }
      }
    });

    //robot-queued tasks, round robin
    let queueCopies = robotIds.map((robotId) => (tqs[robotId] || []).slice()).filter((q) => q.length);
    while (queueCopies.length) {
      queueCopies.forEach((q) => conditionalQueue({ task: q.shift() }));
      queueCopies = queueCopies.filter((q) => q.length);
    }

    //triage
    if (!localRobotId) (tqs.triage || []).forEach((task) => conditionalQueue({ task }));

    //consolidate
    let consolidated = [];
    let processedBatchIds = {};

    displayTasks.forEach(({ task, inProgress }) => {
      if (!this.showUnrelated() && !this.isRelated(task)) {
        return;
      }

      let batchId = task.task_data.batch_uuid;
      if (!batchId) {
        consolidated.push({ task, inProgress });
        return;
      }

      if (processedBatchIds[batchId]) return;
      processedBatchIds[batchId] = true;

      let tasks = getBatchTasks(batchId);
      if (!tasks.length) {
        debugger;
        return;
      }

      let pickup = tasks.find((t) => t.task_type == pickupTaskType);
      let dropoff = tasks.find((t) => t.task_type == dropoffTaskType);

      if (!pickup || !dropoff) {
        debugger;
        if (pickup || dropoff) {
          consolidated.push({ task, inProgress });
        }
        return;
      }

      let combinedTask = {
        task_level_args: {
          start_goal: pickup.task_level_args.start_goal,
          end_goal: dropoff.task_level_args.end_goal,
        },
        task_data: {
          sender_note: pickup.task_data.sender_note || dropoff.task_data.sender_note || '',
        },
      };

      inProgress = inProgress || [pickup, dropoff].some((t) => ['request', 'todo'].indexOf(t.status) < 0);

      consolidated.push({ task: combinedTask, inProgress });
    });
    displayTasks = consolidated;

    let subtitleStyle = {
      textAlign: 'center',
      fontWeight: 400,
      fontSize: mobile ? 12 : 24,
      marginBottom: 4,
    };
    let availableBotsStyle = {
      textAlign: 'center',
      fontWeight: 400,
      fontSize: mobile ? 12 : 24,
      marginBottom: 4,
      color: moxiVerdigris,
    };
    
    // Kiosks display the number of robots in service, Robots display queue status
    let description = this.getQueueDescription(displayTasks);
    let descriptionStyle = subtitleStyle;
    if(this.showRobotsInService()){
      let availableBots = this.getRobotsInService(robotIds);
      description = availableBots < 1 ? `No robots in service at the moment` : `${availableBots} Robot${availableBots > 1 ? `s` : ``} in Service`;
      descriptionStyle = availableBotsStyle;
    }
    

    let currentStatusViewData = {
      title: localRobotId ? 'Current Task' : 'Current Tasks',
      actionsAndStatuses: this.state.actionsAndStatuses,
    };

    let taskAttrs = {};
    if (localRobotId) {
      let ss = this.state.stepStatus;
      if (ss && ss.task_type == getDeliveryType()) {
        try {
          taskAttrs = extractTaskAttrs(ss.task_uuid, this.tasks);
        }
        catch (e) {
          let taskId = ss.task_uuid || 'none';
          if(allowMulti(`homescreenNoTask${taskId.slice(0, 6)}`, 1, 1)) {
            elasticLogError({
              what: 'extractTaskAttrs',
              taskId: ss.task_uuid,
              msg: `could not find task ${taskId} in task-cache, falling back to step status info`,
              errorStr: `${e}`
            });
          }

          taskAttrs = extractFallbackTaskAttrs(ss);
        }
      }
    }

    const taskContextProps = {
      taskAttrs, //used by Load/Unload,
      tasks: this.tasks, //used by Load/Unload
      batchAssist: this.getBatchAssist(),
      queueLength: displayTasks.length, //used by SendScreen
      kioskSettings: this.state.kioskSettings,
      allKioskSettings: this.state.allKioskSettings,

      //TODO: collapse these?
      enabledKioskFriendlyNames: this.state.enabledKioskFriendlyNames,
      getEnabledKioskFriendlyNames:this.getEnabledKioskFriendlyNames,

      autoPrioConfig:this.state.autoPrioConfig,
      getOpenHoursInfo:this.getOpenHoursInfo
    };

    let tall = this.state.tall;

    let marginsLR = tall ? 0 : 32;
    let colStyle = {
      marginLeft: marginsLR,
      marginRight: marginsLR,
      width: tall ? '90%' : '100%',
      display: 'flex',
      flexFlow: 'column',
      ...noSelect,
    };

    let maxLeftWidth = undefined; //tall? '30%' : undefined;
    let maxRightWidth = undefined; //mobile? '55%' : undefined;

    let leftColStyle = { ...colStyle, flex: tall ? undefined : 1, maxWidth: maxLeftWidth };
    let rightColStyle = { ...colStyle, flex: 1, maxWidth: maxRightWidth };

    let colTitleStyle = {
      marginBottom: '12px',
      textAlign: 'center',
      fontWeight: 700,
      fontSize: mobile ? 14 : 36,
      marginTop: 25,
    };

    let robot = this.state.deployedRobot;
    let acceptingTasks = robot && robot.accepting_tasks;

    let wrappingStyle = {
      display: 'flex',
      flexDirection: tall ? 'column' : 'row',
      width: '100%',
      flex: 1,
      alignItems: tall ? 'center' : undefined,
    };
    if (mobile) wrappingStyle.paddingTop = 15;

    let mobileButtonFont = mobile ? { fontSize: 12 } : {};

    const hideTextDisplay = () => {
      this.setShowTextDisplay(false);
    };

    const { kioskSettings } = this.state;

    const showRequestMoxi =
      typeof getSettingValue(kioskSettings, KIOSK_SETTINGS.RequestMoxi) == 'boolean'
        ? getSettingValue(kioskSettings, KIOSK_SETTINGS.RequestMoxi)
        : true;

    const showCancel =
      typeof getSettingValue(kioskSettings, KIOSK_SETTINGS.CancelTasks) == 'boolean'
        ? getSettingValue(kioskSettings, KIOSK_SETTINGS.CancelTasks)
        : true;

    const taskQueueView = () => (
      <div style={wrappingStyle}>
        <div style={leftColStyle}>
          {!mobile && !tall && <div style={colTitleStyle}>Current Task</div>}
          {!tall && <div style={{ flex: 1 }} />}
          <CurrentStatusView tallMobile={false} item={currentStatusViewData} robot={this.state.deployedRobot} />
        </div>

        <div style={rightColStyle}>
          {!mobile && !tall && <div style={colTitleStyle}>Queue</div>}
          <div style={{ ...descriptionStyle }}>{description}</div>
          <QueueView
            displayTasks={displayTasks}
            presentModal={this.presentModal}
            closeModal={this.closeModal}
            onError={() => this.setState({ showError: true })}
            setReorderError={(msg) => this.setReorderError(msg)}
            primeAudio={() => this.primeAudio()}
            showRequestMoxi={showRequestMoxi}
            showCancel={showCancel}
            robotMap={this.state.robotRecs}
            getEnabledKioskFriendlyNames={this.getEnabledKioskFriendlyNames}
            getOpenHoursInfo={this.getOpenHoursInfo}
            autoPrioConfig={this.state.autoPrioConfig}
          />
        </div>
      </div>
    );

    let doorLoiter = this.state.doorLoiter;
    const showLoitering = !!doorLoiter && !doorLoiter.dismissedTicks;
    const loiterPad = 20;

    const estopPanelHeight = 297;
    const ratio = estopPanelHeight / 297;
    const estopDotHeight = 108 * ratio;
    const estopDotTop = 129 * ratio - estopDotHeight / 2;
    const estopDotLeft = 339 * ratio - estopDotHeight / 2;
    const estop = this.state.estop;

    let interstitial;   //() => string
    if(this.state.autoPrioConfig?.allowInterstitials) {
      interstitial = getShared().interstitial;
      if(interstitial && !interstitial())
        interstitial = undefined;
    }

    let moreControls;
    if(!this.state.modalScreen && !getRobotId() && this.state.autoPrioConfig?.enableBadgeReports) {
      moreControls = <div style={turqoiseBtnStyle({marginRight:40, fontSize:20})} 
        onClick={e => this.setState({badgeReport:{station:e.ctrlKey ? '*' : getUnitWp()}})}>Task Data</div>
    }

    return (
      <MoxiModalProvider {...taskContextProps}>
        <div
          style={{
            backgroundColor: '#fff',
            display: 'flex',
            flexFlow: 'column',
            height: '100vh',
            position: 'relative',
            ...noTouchAction,
          }}
        >
          {!!this.state.modalScreen && (
            <ModalView
              screen={this.state.modalScreen}
              closeModal={this.closeModal}
              chime={() => this.clickPlay(arrivalSoundName)}
            />
          )}

          {!this.state.modalScreen && !this.state.showTextDisplay && (
            <Header primeAudio={(makeSound) => this.primeAudio(makeSound)} 
              moreControls={moreControls}
            />
          )}

          {!this.state.modalScreen && (this.state.showTextDisplay ? 
              (<TextDisplayView text={this.state.textDisplay} clickButton={hideTextDisplay} />) : 
              taskQueueView()
          )}

          {this.state.showError && (
            <ErrorBanner
              title={this.state.errorPrompt.title}
              message={this.state.errorPrompt.message}
              dismiss={() => this.setState({ showError: false })}
            />
          )}

          {!this.state.showError && !this.state.modalScreen && !this.state.showTextDisplay && <VersionDisplay />}

          {!this.state.showError &&
            !this.state.modalScreen &&
            !this.state.showTextDisplay &&
            (getRobotId()) && <div style={{ height: 25 }} />}
        </div>

        <span ref={(el) => (this.audioClickEl = el)} onClick={() => this.clickPlayCB()}></span>
        <audio
          ref={(el) => {
            this.playerEl = el;
            if (el && !el._sndInited) {
              el._sndInited = true;
              if(getAudioPrimed())  //250430
                Audio.playSound('unsilence', el); //briefSilence
            }
          }}
        ></audio>

        {!!this.state.funFact && (
          <Dialog
            title={`${getRobotId() ? 'Moxi' : 'This kiosk'} has been refreshed`}
            text={`Did you know: ${this.state.funFact}`}
            primaryButtonText="Okay"
            primaryButtonColor={'#0091ae'}
            primaryButtonWidth={220}
            clickPrimaryButton={() => this.funFactTapped()}
          />
        )}

        {showLoitering && (
          <div
            style={{
              position: 'absolute',
              left: doorLoiter.left,
              top: 0,
              bottom: 0,
              width: `calc(100% - ${2 * loiterPad}px`,
              transition: doorLoiter.transition,
              backgroundColor: '#03a4b5',
              display: 'flex',
              flexFlow: 'column',
              alignItems: 'center',
              padding: loiterPad,
              ...noSelect,
            }}
          >
            <div style={{ display: 'flex', flexFlow: 'row', width: '100%' }}>
              <img
                src={require('../assets/images/welcome_diligent_logo.png')}
                draggable={false}
                style={{ width: 100, height: 40 }}
              />
              <div style={{ flex: 1 }} />
              <img
                src={require('../assets/images/moxi-at-door.png')}
                draggable={false}
                style={{ height: 'calc(100vh - 400px)' }}
              />
              <div style={{ flex: 1 }} />
              <img
                src={'white-x.png'}
                draggable={false}
                style={{ width: 40, height: 40, marginLeft: 60, cursor: 'pointer' }}
                onClick={() => this.dismissDoorHelp()}
              />
            </div>

            <div style={{ marginTop: 30, color: 'white', fontSize: 60, textAlign: 'center', fontWeight: 'bold' }}>
              Moxi is waiting to be let in through the door
            </div>
            <div
              style={{
                marginTop: 30,
                color: 'white',
                border: '4px solid white',
                borderRadius: '1em',
                width: '6em',
                fontSize: 40,
                textAlign: 'center',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
              onClick={() => this.dismissDoorHelp()}
            >
              GOT IT
            </div>
          </div>
        )}

        {!estop && !!interstitial && (
          <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0,
              backgroundColor: '#26a1b6', display: 'flex', flexFlow: 'column', alignItems: 'center', justifyContent:'center',
              padding: 30, ...noSelect}}
          >
            <div style={{color:'white', fontSize:60, textWrap:'balance', textAlign:'center'}}>{interstitial()}</div>
          </div>
        )}

        {!!estop && (
          <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0,
              backgroundColor: '#26a1b6', display: 'flex', flexFlow: 'column', alignItems: 'center', padding: 30, ...noSelect}}
          >
            <div style={{ marginTop: 20, color: 'red', fontSize: '15vh', minHeight: '1em', maxHeight: '1em', minWidth: '1em', maxWidth: '1em',
                fontWeight: 'bold', backgroundColor: 'white', borderRadius: '50%', textAlign: 'center', display: 'flex',
                flexFlow: 'column', alignItems: 'center', justifyContent: 'center' }}
            >
              {!!estop.bang ? '!' : ''}
            </div>

            <div style={{ marginTop: 20, color: 'white', fontSize: '10vh', textAlign: 'center', fontWeight: 'bold' }}>
              I could use your help
            </div>

            <div style={{ marginTop: 15, color: 'white', fontSize: '4vh', textAlign: 'center', textWrap: 'balance' }}>
              Resume me so I can deliver <span style={{ fontWeight: 'bold' }}>important patient care items</span>.
              Slightly rotate the button on the <span style={{ fontWeight: 'bold' }}>left side of my base</span>.
            </div>

            <div style={{ position: 'relative' }}>
              <img
                style={{ marginTop: 10, height: estopPanelHeight }}
                src={require('../assets/images/estop-button.png')}
              />
              <img
                style={{
                  animation: 'rotatedot 3s infinite',
                  rotate: '40deg',
                  position: 'absolute',
                  left: estopDotLeft,
                  top: estopDotTop,
                  height: estopDotHeight,
                }}
                src={require('../assets/images/estop-dot.png')}
              />
            </div>
          </div>
        )}

      </MoxiModalProvider>
    );
  }
}

HomeScreen.navigationOptions = {
  header: null,
};

// Note: This is needed because publishing to expo runs minify, which changes the class names. In particular, classes
//       can end up with the same name which breaks the screen transition logic.
HomeScreen.viewName = 'HomeScreen';
